import Backbone from 'backbone'
import template from './empty-state.hbs'

/**
 * @param {Object} options Configuration options for EmptyState
 * @param {boolean} [options.noHeader=false] Set true if there should be no
 * header on the empty state
 * @param {string} [options.extraClass] Additional class(es) to apply to the button
 * @param {Object} [options.displayHeaderTabs] Pass in displayHeaderTabs
 * object to display tabs at the top.
 *
 * Example usage:
 * appDisplay.display( new EmptyState({ body: template() }).render().el )
 */

var EmptyState = Backbone.View.extend({

	className: 'display-layout empty-state',

	initialize: function(options) {
		this.options = options || {}
		this.options.type = 'empty'
	},

	render: function() {
		this.$el.append(template({
			heading: this.options.heading,
			noHeader: this.options.noHeader,
			displayHeaderTabs: this.options.displayHeaderTabs
		}))

		if (this.options.body) {
			this.$('.display-pane-body').append(this.options.body)
		}
		return this
	}
})

export default EmptyState

EmptyState.__filename__ = 'components/empty-state.js'
